import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-y301fs-0"
})(["table{td{width:25%;width:300px;border-right:1px solid ", ";background-color:transparent;&:first-child{font-weight:700;text-align:left;}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryM;
});
export var ModalInner = styled.div.withConfig({
  displayName: "partials__ModalInner",
  componentId: "sc-y301fs-1"
})(["padding:20px;background-color:", ";display:flex;flex-direction:column;h4{margin-bottom:24px;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiA;
});